import React from "react";

const Content = (props) => {
  const { children } = props;
  return <main className="c-main">{children}</main>;
};

export default React.memo(Content);
